import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";

export const Title = styled(Typography)({
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    color: "var(--community-color-primary-text)",
    paddingTop: ".5rem",
    paddingBottom: ".5rem",
    fontFamily:
        'system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol !important',
});

export const PromoPostsContainer = styled(Box)({
    marginBottom: "-20px",
});
